import React from 'react';
import { DocNode } from '../models/types';

interface Props {
  nodes: DocNode[];
  onSelect: (path: string) => void;
  selectedPath?: string;
  depth?: number;
}

export const DocsTree = ({ nodes, onSelect, selectedPath, depth = 0 }: Props): JSX.Element => (
  <div className="docs-tree">
    {nodes.map((node) => {
      const isSelected = selectedPath === node.path;
      const indent = depth * 12;

      return (
        <div key={node.id} style={{ marginLeft: `${indent}px` }}>
          {node.type === 'file' && (
            <button
              type="button"
              onClick={() => onSelect(node.path)}
              style={{ fontWeight: isSelected ? 700 : 500 }}
            >
              {node.name}
            </button>
          )}
          {node.type === 'folder' && (
            <>
              <strong style={{ display: 'block', margin: '6px 0 2px' }}>{node.name}</strong>
              {node.children && (
                <DocsTree
                  nodes={node.children}
                  onSelect={onSelect}
                  selectedPath={selectedPath}
                  depth={depth + 1}
                />
              )}
            </>
          )}
        </div>
      );
    })}
  </div>
);
